export default "__VITE_ASSET__e418444b__"